import React from 'react'
import { ValueLocked } from 'src/components/framework/icons/value-locked'
import { Column, Grid } from 'src/components/framework/ui'
import { SectionHeader } from 'src/components/framework/ui/section-header'
import { RatioLink } from 'src/components/page/ratios/ratios'

export const OtherRatios: React.FC = () => {
  return (
    <>
      <SectionHeader>Other Ratios</SectionHeader>
      <table
        className={'stk-table-stretched stk-space-out-t-0 stk-space-out-b-3'}
      >
        <thead>
          <tr>
            <th>Leverage (ttm)</th>
            <th className={'stk-text-align-r'}>Total</th>
            <th className={'stk-text-align-r'}>- Intang</th>
            <th className={'stk-text-align-r'}>+ Pension</th>
          </tr>
        </thead>
        <tbody>
          {LEVERAGE_RATIOS.map((ratio, index) => (
            <tr key={index}>
              <td>
                <RatioLink id={ratio.id}>{ratio.name}</RatioLink>
              </td>
              <td className={'stk-text-align-r'}>
                <ValueLocked />
              </td>
              <td className={'stk-text-align-r'}>
                <ValueLocked />
              </td>
              <td className={'stk-text-align-r'}>
                <ValueLocked />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      <Grid>
        <Column>
          <table className={'stk-table-stretched'}>
            <thead>
              <tr>
                <th colSpan={2}>Liquidity (ttm)</th>
              </tr>
            </thead>
            <tbody>
              {LIQUIDITY_RATIOS.map((ratio, index) => (
                <tr key={index}>
                  <td>
                    <RatioLink id={ratio.id}>{ratio.name}</RatioLink>
                  </td>
                  <td className={'stk-text-align-r'}>
                    <ValueLocked />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </Column>
        <Column>
          <table className={'stk-table-stretched'}>
            <thead>
              <tr>
                <th colSpan={2}>Efficiency (ttm)</th>
              </tr>
            </thead>
            <tbody>
              {EFFICIENCY_RATIOS.map((ratio, index) => (
                <tr key={index}>
                  <td>
                    <RatioLink id={ratio.id}>{ratio.name}</RatioLink>
                  </td>
                  <td className={'stk-text-align-r'}>
                    <ValueLocked />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </Column>
      </Grid>
    </>
  )
}

interface Ratio {
  name: string
  id: string
}

const LEVERAGE_RATIOS: ReadonlyArray<Ratio> = [
  { name: 'Gross Gearing', id: 'gross-gearing-905' },
  { name: 'Net Gearing', id: 'net-debt-to-equity-495' },
  { name: 'Cash / Assets', id: 'cash-to-assets-ratio-144' },
]

const LIQUIDITY_RATIOS: ReadonlyArray<Ratio> = [
  { name: 'Curr. Ratio', id: 'current-ratio-198' },
  { name: 'Quick Ratio', id: 'quick-ratio-last-interim-period-758' },
  { name: 'Interest Cov.', id: 'interest-cover-433' },
]

const EFFICIENCY_RATIOS: ReadonlyArray<Ratio> = [
  { name: 'Asset Turnover', id: 'asset-turnover-trailing-12m-49' },
  { name: 'Recs Turnover', id: 'receivables-turnover-trailing-12m-765' },
  { name: 'Stock Turnover', id: 'inventory-turnover-trailing-12m-445' },
]
